import axios from "axios";
import { FormEvent } from "react";
import { toast } from "react-toastify";
import { SetState } from "zustand";
import { ICarcerarioRGstore } from "..";
import { IConsultaCarcerario } from "../../../interface/fichaCarcerario";

export interface ICarcerarioRGModuleStore {
  resultadoCarcerarioRG: IConsultaCarcerario[] | null;
  mensagemCarcerario?: string;
  consultaCarcerarioRG(
    urlCarcerario: string,
    rg: string,
    e?: FormEvent
  ): Promise<void>;
  limparConsultaCarcerarioRG(): void;
}

export default (set: SetState<ICarcerarioRGstore>) =>
  ({
    resultadoCarcerarioRG: null,
    async consultaCarcerarioRG(urlCarcerario, rg, e) {
      e?.preventDefault();
      try {
        const storedToken = sessionStorage.getItem("@webSDS:token");

        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: true,
          },
        }));
        if (rg === "") {
          toast.error("Preencha o campo!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        } else {
          const response = await axios.get(`${urlCarcerario}/carcerario`, {
            params: {
              DET_RG: rg,
            },
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          });

          if (response.status === 200) {
            set((state) => ({
              ...state,
              global: {
                ...state.global,
                loading: false,
              },
              carcerario: {
                ...state.carcerario,
                resultadoCarcerarioRG: response.data,
              },
            }));
          }
          if (response.status === 400) {
            toast.error(`${response.data.message}`, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
          }
          if (response.status === 401) {
            toast.error(
              "A SUA SESSÃO EXPIROU, EFETUE LOGIN NOVAMENTE PARA CONTINUAR USANDO O POLÍCIA ÁGIL.",
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              }
            );
            // logout()
          }
          if (response.status === 404) {
            set((state) => ({
              carcerario: {
                ...state.carcerario,
                resultadoCarcerarioRG: null,
                mensagemCarcerario: response.data.message,
              },
            }));
          }
          if (response.status === 500 || response.status === 503) {
            toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
            return;
          }
          if (response.status === 504 || response.data === 504) {
            toast.error(
              "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              }
            );
            return;
          }
        }
      } catch (error) {
        toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      } finally {
        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: false,
          },
        }));
      }
    },
    limparConsultaCarcerarioRG() {
      set((state) => ({
        ...state,
        carcerario: {
          ...state.carcerario,
          resultadoCarcerarioRG: null,
          mensagemCarcerario: undefined,
        },
      }));
    },
  } as ICarcerarioRGModuleStore);
